import { Store } from 'components/common/types/Store.types';

export const getIsSchedulePanelFilled = (state: Store): boolean => {
  const { startDate, endDate } = state.dealManagement.commonDeal.currentLine;
  return Boolean(startDate) && Boolean(endDate);
};

export const getIsEnvironmentPanelFilled = (state: Store): boolean => {
  return Boolean(state.dealManagement.commonDeal.currentLine.environments?.length);
};

export const getIsCpmPanelFilled = (state: Store): boolean =>
  Number(state.dealManagement.commonDeal.currentLine.cpm ?? 0) > 0;

export const getIsMediaOwnerPanelFilled = (state: Store): boolean => {
  return Boolean(state.dealManagement.commonDeal.currentLine.mediaOwnerMeta?.length);
};

export const getIsMediaTypePanelFilled = (state: Store): boolean => {
  return Boolean(state.dealManagement.directSales?.mediaType);
};

export const getIsTargetsPanelFilled = (state: Store): boolean => {
  const { budget, frames, impressions } = state.dealManagement.commonDeal.currentLine;

  return Boolean(budget || frames || impressions);
};

export const getIsNetworksPanelFilled = (state: Store): boolean =>
  Boolean(state.dealManagement.directSales?.networkCriteria?.length);

export const getIsFrameCPMPanelFilled = (state: Store): boolean => {
  const { minCPM, maxCPM } = state.dealManagement.commonDeal.currentLine;

  return minCPM !== undefined || maxCPM !== undefined;
};

export const getIsDSPPanelFilled = (state: Store): boolean =>
  Boolean(state.dealManagement.programmatic?.dsp?.code ?? '');
